export default {
  // props: ["id", "index", "value"],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isShowSlide: false // 是否显示配置页面
    };
  }
};